import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ModalHeader from "../../../Utills/ModalHeader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  maxHeight: "90vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const OrderInfoDetailModal = ({ handleClose, open, data }) => {
    console.log("Админ талд ирж байгаа deliveryDate:", data?.deliveryDate);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("mn-MN");
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <ModalHeader
          title={"Захиалгын дэлгэрэнгүй"}
          handleClose={handleClose}
        />

        {/* Захиалагчийн мэдээлэл */}
        <Typography variant="h6" className="font-bold mb-2">
          Захиалагчийн мэдээлэл:
        </Typography>
        <Typography
          className="grid grid-cols-2 gap-2 py-1 pb-4"
          variant="body1"
        >
          <p>Овог: {data.lastName}</p>
          <p>Нэр: {data.firstName}</p>
          <p>Утасны дугаар: {data.phone}</p>
          <p>И-Мэйл: {data.email}</p>
        </Typography>

        {/* Компанийн мэдээлэл */}
        {data.companyName && (
          <>
            <Typography variant="h6" className="font-bold mb-2">
              Компанийн мэдээлэл:
            </Typography>
            <Typography
              className="grid grid-cols-2 gap-2 py-1 pb-4"
              variant="body1"
            >
              <p>Компанийн нэр: {data.companyName}</p>
              <p>Регистрийн дугаар: {data.companyReg}</p>
            </Typography>
          </>
        )}

        {/* Хүлээн авагчийн мэдээлэл */}
        <Typography variant="h6" className="font-bold mb-2">
          Хүлээн авагчийн мэдээлэл:
        </Typography>
        <Typography
          className="grid grid-cols-2 gap-2 py-1 pb-4"
          variant="body1"
        >
          <p>Овог: {data.receiverLastName}</p>
          <p>Нэр: {data.receiverName}</p>
          <p>Утасны дугаар: {data.receiverPhone}</p>
        </Typography>

        {/* Хаягийн мэдээлэл */}
        <Typography variant="h6" className="font-bold mb-2">
          Хаягийн мэдээлэл:
        </Typography>
        <Typography
          className="grid grid-cols-2 gap-2 py-1 pb-4"
          variant="body1"
        >
          <p>Дүүрэг: {data.district}</p>
          <p>Хороо: {data.subdistrict}</p>
          <p>Дэлгэрэнгүй хаяг: {data.address}</p>
          <p>Хүргэх өдөр: {data.deliveryDate}</p>
        </Typography>

        {/* Захиалгын мэдээлэл */}
        <Typography variant="h6" className="font-bold mb-2">
          Захиалгын мэдээлэл:
        </Typography>
        <Typography
          className="grid grid-cols-2 gap-2 py-1 pb-4"
          variant="body1"
        >
          <p>Захиалгын огноо: {formatDate(data.createdAt)}</p>
          <p>Нийт үнэ: {Intl.NumberFormat("en-us").format(data.price)}₮</p>
          <p>
            Төлбөр: {data.isPaid ? "Төлбөр төлөгдсөн" : "Төлбөр төлөгдөөгүй"}
          </p>
          <p>Хүргэлт: {data.isDelivery ? "Хүргэлттэй" : "Хүргэлтгүй"}</p>
          <p>
            Хүргэгдсэн эсэх: {data.isDelived ? "Хүргэгдсэн" : "Хүргэгдээгүй"}
          </p>
          <p>Захиа: {data.message}</p>
        </Typography>

        {/* Захиалсан бараанууд */}
        <Typography variant="h6" className="font-bold mb-2">
          Захиалсан бараанууд:
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ background: "#c7e7cf" }}>
              <TableRow>
                <TableCell>№</TableCell>
                <TableCell align="right">Нэр</TableCell>
                <TableCell align="right">Үнэ</TableCell>
                <TableCell align="right">Хэмжээ /ш/</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.orders.map((row, index) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell align="right">{row.name}</TableCell>
                  <TableCell align="right">
                    {Intl.NumberFormat("en-us").format(row.price)}₮
                  </TableCell>
                  <TableCell align="right">{row.quality} /ш/</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};

export default OrderInfoDetailModal;
